import { addBusinessDays } from "date-fns";

// Must match TicketController::MIN_DUE_DATE_DAYS_AHEAD — the backend rejects anything sooner.
export const MIN_DUE_DATE_DAYS_AHEAD = 5;

/**
 * Earliest due date allowed for a ticket created at `createdAt` (defaults to now, i.e. a new ticket).
 * Counts working days only (Mon–Fri) — same as Carbon's addWeekdays() on the backend.
 */
export const earliestDueDate = (createdAt = new Date()) => {
	const date = new Date(createdAt);
	date.setHours(0, 0, 0, 0);
	return addBusinessDays(date, MIN_DUE_DATE_DAYS_AHEAD);
};
